import React from 'react';

import { DeleteButton } from 'craft/containers/FloatingMenu/commons/DeleteButton';
import { useMutations } from 'craft/hooks';

export const DeleteTooltipButton = ({
  nodeId,
  disabled,
  tooltipPlacement,
}: {
  nodeId: string;
  disabled: boolean;
  tooltipPlacement: 'top' | 'bottom';
}) => {
  const { deleteNode } = useMutations();

  const onDelete = () => deleteNode([nodeId]);

  return (
    <DeleteButton tooltipPlacement={tooltipPlacement} disabled={disabled} onClick={onDelete} />
  );
};
